import { render, staticRenderFns } from "./KnowledgeFromRep.vue?vue&type=template&id=02db2982&scoped=true&"
import script from "./KnowledgeFromRep.vue?vue&type=script&lang=js&"
export * from "./KnowledgeFromRep.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/knowledge.css?vue&type=style&index=0&lang=css&"
import style1 from "./KnowledgeFromRep.vue?vue&type=style&index=1&id=02db2982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02db2982",
  null
  
)

export default component.exports